import ApiService from '@/services/core/api.service'

const ItemCenterService = {
  async get (query = '') {
    return ApiService.get(`budget-officer/item-centers?${query}`)
  },

  async show (itemCenter, query = '') {
    return ApiService.get(`budget-officer/item-centers/${itemCenter}?${query}`)
  },

  async post (payload) {
    return ApiService.post('budget-officer/item-centers', payload)
  },

  async put (payload) {
    return ApiService.put(`budget-officer/item-centers/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`budget-officer/item-centers/${payload.id}`)
  },

  async export (query = '') {
    return ApiService.get(`budget-officer/exports/item-centers?${query}`)
  },

  async exportRequests (itemCenter, query = '') {
    return ApiService.get(`budget-officer/exports/payment-requests/${itemCenter}?${query}`)
  }
}

export default ItemCenterService
